import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as codeApi from '../../lib/api/invoiceMaintenanceCode';

// 1. 액션 타입 정의
const [
  LIST_INVOICE_MAINTENANCE, 
  LIST_INVOICE_MAINTENANCE_SUCCESS, 
  LIST_INVOICE_MAINTENANCE_FAILURE
] = createRequestActionTypes('invoiceMaintenance/LIST_INVOICE_MAINTENANCE');

const [
  UPDATE_INVOICE_MAINTENANCE, 
  UPDATE_INVOICE_MAINTENANCE_SUCCESS, 
  UPDATE_INVOICE_MAINTENANCE_FAILURE
] = createRequestActionTypes('invoiceMaintenance/UPDATE_INVOICE_MAINTENANCE');

// [추가] 일괄 발행 액션 타입
const [
  UPDATE_BULK_INVOICE, 
  UPDATE_BULK_INVOICE_SUCCESS, 
  UPDATE_BULK_INVOICE_FAILURE
] = createRequestActionTypes('invoiceMaintenance/UPDATE_BULK_INVOICE');

// 2. 액션 생성 함수
export const listInvoiceMaintenance = createAction(LIST_INVOICE_MAINTENANCE, (searchData) => searchData);
export const updateInvoiceMaintenance = createAction(UPDATE_INVOICE_MAINTENANCE, (updateData) => updateData);
// [추가] 일괄 발행 액션 생성 함수
export const updateBulkInvoice = createAction(UPDATE_BULK_INVOICE, (bulkData) => bulkData);

// 3. 사가(Saga) 구성
const listInvoiceMaintenanceSaga = createRequestSaga(LIST_INVOICE_MAINTENANCE, codeApi.getInvoiceMaintenanceList);

function* updateInvoiceMaintenanceSaga(action) {
  try {
    const response = yield call(codeApi.updateInvoiceMaintenance, action.payload);
    yield put({
      type: UPDATE_INVOICE_MAINTENANCE_SUCCESS,
      payload: response.data,
    });
    // 성공 후 재조회
    const searchParams = action.payload.searchParams || {};
    yield put(listInvoiceMaintenance(searchParams));
  } catch (e) {
    yield put({
      type: UPDATE_INVOICE_MAINTENANCE_FAILURE,
      payload: e,
      error: true,
    });
  }
}

// [추가] 일괄 발행 사가
function* updateBulkInvoiceSaga(action) {
  try {
    // API 호출 (서버에서 배열 형태로 데이터를 받아 처리한다고 가정)
    const response = yield call(codeApi.updateInvoiceMaintenanceBulk, action.payload);
    
    yield put({
      type: UPDATE_BULK_INVOICE_SUCCESS,
      payload: response.data,
    });

    // 일괄 발행 성공 후 리스트 재조회 (데이터 최신화 및 체크박스 상태 초기화 유도)
    const searchParams = {
      ...action.payload.searchParams,
      invYn: action.payload.searchParams?.invYn || 'N' // 값이 없으면 기본 'N' 처리
    };
    yield put(listInvoiceMaintenance(searchParams));

  } catch (e) {
    yield put({
      type: UPDATE_BULK_INVOICE_FAILURE,
      payload: e,
      error: true,
    });
  }
}

export function* invoiceMaintenanceSaga() {
  yield takeLatest(LIST_INVOICE_MAINTENANCE, listInvoiceMaintenanceSaga);
  yield takeLatest(UPDATE_INVOICE_MAINTENANCE, updateInvoiceMaintenanceSaga);
  yield takeLatest(UPDATE_BULK_INVOICE, updateBulkInvoiceSaga); // 추가
}

// 4. 초기 상태 및 리듀서
const initialState = {
  list: null,
  saveResult: null,
  listError: null,
  saveError: null,
};

const invocieMaintenance = handleActions(
  {
    [LIST_INVOICE_MAINTENANCE_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      list: data.list.map((value) => ({
        id: value.waitUuid,
        prjUuid: value.prjUuid,
        salDt: value.salDt,
        partnerNm: value.partnerNm,
        partnerUuid: value.vendorCmp,
        salDet: value.salDet,
        cstNm: value.cstNm,
        invNo: value.invNo,
        inspectCon: value.inspectCon,
        osTran: value.osTran,
        expSales: value.expSales,
        salBal: value.salBal,
        salAmt: value.salAmt,
        salVat: value.salVat,
        totalSalAmt: value.totalSalAmt,
        colDt: value.colDt,
        invYn: value.invYn,
        prevInvYn: value.prevInvYn,
        dptUuid: value.dptUuid,
        usrNm: value.usrNm
      })),
      listError: null,
    }),
    [LIST_INVOICE_MAINTENANCE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      listError: error,
    }),
    [UPDATE_INVOICE_MAINTENANCE_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      // 개별 업데이트 시 해당 항목만 상태 변경 (재조회 전 즉시 반영용)
      list: state.list.map((item) =>
        item.id === data.waitUuid ? { ...item, inspectCon: 'Y' } : item
      ),
      saveError: null,
    }),
    // [추가] 일괄 발행 성공/실패 처리
    [UPDATE_BULK_INVOICE_SUCCESS]: (state) => ({
      ...state,
      saveError: null,
    }),
    [UPDATE_BULK_INVOICE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      saveError: error,
    }),
  },
  initialState,
);

export default invocieMaintenance;
